import { CountryCode, PointLocation } from "../data/LockerDataTypes";
import { IMapCenter } from "../data/MapCenter";
import { Api } from "../utils/Api";

export class HungaryMapCenter implements IMapCenter {
    value: any;
    order: number;

    constructor(value: any, order: number) {
        this.value = value;
        this.order = order;
    }

    IsApplicable(): boolean {
        return this.value == CountryCode.Hungary;
    };

    async Run(): Promise<PointLocation> {
        return Api.Get().GetCapitalCenterPoint(this.value)
    };
}